import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue";
const _hoisted_1 = {
    ref: "akbheader",
    id: "akheader",
    class: "fixed-top d-md-none d-sm-none d-none d-lg-block"
};
const _hoisted_2 = { class: "container" };
const _hoisted_3 = { class: "row" };
const _hoisted_4 = { class: "col-md-4 d-sm-none d-md-block" };
const _hoisted_5 = { id: "logo" };
const _hoisted_6 = { href: "https://www.ak-berlin.de" };
const _hoisted_7 = { class: "col-md-8 p-0 aknav" };
const _hoisted_8 = { class: "navbar-expand-lg aknav-top p-0 pt-2" };
const _hoisted_9 = { class: "navbar-nav" };
const _hoisted_10 = { class: "nav-item" };
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("nav", { class: "navbar" }, [
    /*#__PURE__*/ _createElementVNode("div", {
        class: "collapse navbar-collapse",
        id: "akb-navbar"
    }, [
        /*#__PURE__*/ _createElementVNode("ul", { class: "nav navbar-nav" })
    ])
], -1);
const _hoisted_12 = {
    id: "akheadermobile",
    class: "ak-header-mobile fixed-top d-xl-none d-lg-none d-md-block d-sm-block d-block"
};
const _hoisted_13 = { class: "navbar navbar-light navbar-akb-mobile" };
const _hoisted_14 = { class: "navbar-brand logo-img-mobile" };
const _hoisted_15 = { class: "logo-img-mob" };
const _hoisted_16 = { href: "https://www.ak-berlin.de" };
const _hoisted_17 = { class: "navbar-button" };
const _hoisted_18 = { class: "center" };
const _hoisted_19 = /*#__PURE__*/ _createElementVNode("span", null, null, -1);
const _hoisted_20 = /*#__PURE__*/ _createElementVNode("span", null, null, -1);
const _hoisted_21 = /*#__PURE__*/ _createElementVNode("span", null, null, -1);
const _hoisted_22 = [
    _hoisted_19,
    _hoisted_20,
    _hoisted_21
];
const _hoisted_23 = {
    role: "main",
    class: "container akb-content"
};
const _hoisted_24 = { class: "row mt-5" };
const _hoisted_25 = { class: "col col-lg-4 d-md-none d-sm-none d-none d-lg-block" };
const _hoisted_26 = /*#__PURE__*/ _createElementVNode("header", null, [
    /*#__PURE__*/ _createElementVNode("h1", null, "   ")
], -1);
const _hoisted_27 = { class: "nav-sidebar" };
const _hoisted_28 = {
    key: 0,
    class: "mt-3",
    style: { "padding-left": "5px" }
};
const _hoisted_29 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_30 = { class: "col col-lg-8 col-md-12 mb-5" };
const _hoisted_31 = { key: 0 };
const _hoisted_32 = {
    key: 1,
    class: "container w-100 ps-0 pe-0 pt-2 pb-2 mb-3 border-bottom"
};
const _hoisted_33 = { class: "row p-0 m-0" };
const _hoisted_34 = { class: "col command-bar" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_banner_panel = _resolveComponent("g-banner-panel");
    const _component_g_icon = _resolveComponent("g-icon");
    const _component_g_link = _resolveComponent("g-link");
    const _component_g_navview = _resolveComponent("g-navview");
    const _component_g_treeview = _resolveComponent("g-treeview");
    const _component_portal_target = _resolveComponent("portal-target");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("header", _hoisted_1, [
            _createVNode(_component_g_banner_panel),
            _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("a", _hoisted_6, [
                                _createVNode(_component_g_icon, {
                                    id: "logo-svg",
                                    src: "/themes/akb/akb-logo.svg"
                                })
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("nav", _hoisted_8, [
                            _createElementVNode("ul", _hoisted_9, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.topMenuEntries, (menuItem) => {
                                    return (_openBlock(), _createElementBlock("li", _hoisted_10, [
                                        _createVNode(_component_g_link, {
                                            src: menuItem.actionCommand,
                                            target: menuItem.actionTarget,
                                            class: "nav-link"
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(menuItem.caption), 1)
                                            ]),
                                            _: 2
                                        }, 1032, ["src", "target"])
                                    ]));
                                }), 256))
                            ])
                        ]),
                        _hoisted_11
                    ])
                ])
            ])
        ], 512),
        _createElementVNode("header", _hoisted_12, [
            _createVNode(_component_g_banner_panel),
            _createElementVNode("nav", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("a", _hoisted_16, [
                            _createVNode(_component_g_icon, {
                                id: "logo-svg2",
                                src: "/themes/akb/akb-logo.svg"
                            })
                        ])
                    ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("button", {
                            onClick: _cache[0] || (_cache[0] =
                                //@ts-ignore
                                (...args) => (_ctx.onMobileNavToogle && _ctx.onMobileNavToogle(...args))),
                            class: _normalizeClass(['navbar-toggler navbar-toggler-right toggler-akb', _ctx.$host.pageMeta.mobileNavVisible ? '' : 'collapsed']),
                            type: "button"
                        }, _hoisted_22, 2)
                    ]),
                    _createVNode(_component_g_navview)
                ])
            ])
        ]),
        _createElementVNode("main", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
                _createElementVNode("aside", _hoisted_25, [
                    _hoisted_26,
                    _createElementVNode("div", _hoisted_27, [
                        _createVNode(_component_g_treeview, {
                            "data-source": _ctx.mainMenuEntries,
                            "key-member": "menuID",
                            "data-structure": "tree"
                        }, null, 8, ["data-source"]),
                        (_ctx.hasUser)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                _createElementVNode("h2", null, _toDisplayString(_ctx.$tc('shared.Page.User')), 1),
                                _createTextVNode(" " + _toDisplayString(_ctx.userDisplayName), 1),
                                _hoisted_29,
                                _createElementVNode("small", null, _toDisplayString(_ctx.userName), 1)
                            ]))
                            : _createCommentVNode("", true)
                    ])
                ]),
                _createElementVNode("section", _hoisted_30, [
                    (_ctx.pageTitle)
                        ? (_openBlock(), _createElementBlock("header", _hoisted_31, [
                            _createElementVNode("h1", null, _toDisplayString(_ctx.pageTitle), 1)
                        ]))
                        : _createCommentVNode("", true),
                    (_ctx.hasCommands)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                            _createElementVNode("div", _hoisted_33, [
                                _createElementVNode("div", _hoisted_34, [
                                    _createVNode(_component_portal_target, {
                                        name: "command-bar",
                                        multiple: ""
                                    })
                                ])
                            ])
                        ]))
                        : _createCommentVNode("", true),
                    _renderSlot(_ctx.$slots, "default")
                ])
            ])
        ])
    ], 64));
}
